export function initSidebarParallax(): void {
  const sidebar =
    document.querySelector<HTMLElement>('.p-shop__intro-sidebar-inner') ||
    document.querySelector<HTMLElement>('.p-shop__article-sidecopy');
  const track =
    document.querySelector<HTMLElement>('.p-shop__intro') ||
    document.querySelector<HTMLElement>('.p-shop__article');
  const info = document.querySelector<HTMLElement>('.p-shop__info');
  if (!sidebar || !track || !info) return;

  let sidebarH: number;
  let sidebarStartOffset: number;
  let trackTop: number;
  let totalTrack: number;
  let maxTranslate: number;
  let factor: number;

  function calc(): void {
    sidebar!.style.transform = '';
    const rect = track!.getBoundingClientRect();
    trackTop = rect.top + window.scrollY;
    const infoTop = info!.getBoundingClientRect().top + window.scrollY;
    const sidebarTop = sidebar!.getBoundingClientRect().top + window.scrollY;
    sidebarH = sidebar!.offsetHeight;
    sidebarStartOffset = sidebarTop - trackTop;
    totalTrack = infoTop - trackTop;
    maxTranslate = Math.max(0, totalTrack - sidebarStartOffset - sidebarH);
    factor = totalTrack > 0 ? maxTranslate / totalTrack : 0;
  }

  let ticking = false;
  function onScroll(): void {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const scrolled = Math.max(0, window.scrollY - trackTop);
      const ty = Math.min(scrolled * factor, maxTranslate);
      sidebar!.style.transform = `translateY(${ty}px)`;
      ticking = false;
    });
  }

  calc();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', () => {
    calc();
    onScroll();
  });
  let resizeTimeout: number;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      calc();
      onScroll();
    }, 200);
  });
}
